import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="header">
          <h1>ChemNucleus Privacy Policy</h1>
          <p className="last-updated">Last Updated: January 2025</p>
        </header>

        <main className="content">
          <section className="section">
            <h2>1. Data Collection</h2>
            <ul>
              <li><strong>Local Storage Only:</strong> Game scores are stored locally on your device via SharedPreferences</li>
              <li><strong>No Personal Information:</strong> We do not collect names, emails, or any contact information</li>
              <li><strong>No User Accounts:</strong> The app does not require registration or login</li>
            </ul>
          </section>

          <section className="section">
            <h2>2. Data Usage</h2>
            <ul>
              <li>Game progress and scores are stored only on your device</li>
              <li>No data is transmitted to external servers</li>
              <li>No analytics or tracking mechanisms are implemented</li>
            </ul>
          </section>

          <section className="section">
            <h2>3. Third-Party Services</h2>
            <p>ChemNucleus does not currently use any third-party services such as:</p>
            <ul>
              <li>Google Play Services</li>
              <li>Advertising networks</li>
              <li>Crash reporting tools</li>
            </ul>
          </section>

          <section className="section">
            <h2>4. Data Sharing</h2>
            <ul>
              <li>We do not share any data with third parties</li>
              <li>We do not sell user data</li>
              <li>All information remains on your device</li>
            </ul>
          </section>

          <section className="section">
            <h2>5. Children's Privacy</h2>
            <ul>
              <li>ChemNucleus is suitable for students, including minors</li>
              <li><strong>COPPA Compliance:</strong> We do not collect personal data from children under 13</li>
              <li>No internet connectivity or data transmission occurs</li>
            </ul>
          </section>

          <section className="section">
            <h2>6. Data Security</h2>
            <ul>
              <li>All data is stored locally on your device</li>
              <li>No online transmission of user data occurs</li>
              <li>Your device's built-in security protects your game data</li>
            </ul>
          </section>

          <section className="section">
            <h2>7. User Rights</h2>
            <ul>
              <li>You can clear app data anytime through your device settings</li>
              <li>Uninstalling the app removes all stored data permanently</li>
              <li>You have full control over your game progress and scores</li>
            </ul>
          </section>

          <section className="section">
            <h2>8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be reflected in the
              "Last Updated" date at the top of this policy. Users will be notified of significant changes
              through app updates and release notes.
            </p>
          </section>

          <section className="section">
            <h2>9. Contact Information</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy, please contact us at:
            </p>
            <p className="contact-email">
              <strong>Email:</strong> <a href="mailto:ahil.kabil.r@gmail.com">ahil.kabil.r@gmail.com</a>
            </p>
          </section>
        </main>

        <footer className="footer">
          <p>&copy; 2025 ChemNucleus. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
